import { Box, CircularProgress, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "context/GlobalContext";
import { converAttrToDatagridCol } from "data/globalData";
import { Fragment, useEffect, useState } from "react";
import { channelTypes } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import styled from "@emotion/styled";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";
import { grey, orange } from "@mui/material/colors";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import axios from "axios";

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		// backgroundColor: "#f5f5f9",
		backgroundColor: "white",
		color: "rgba(0, 0, 0, 0.87)",
		maxWidth: 400,
		fontSize: theme.typography.pxToRem(12),
		border: "1px solid #dadde9",
	},
}));
const RenderQtyRosData = ({ column, data }) => {
	const totalQty =
		isNaN(Number(data[`SOLD_QTY_${column}`]) ?? 1) / Number(data[`COUNT_OPT_${column}`])
			? 0
			: Math.round(roundDecimalValueUptoTwo(Number(data[`SOLD_QTY_${column}`]) ?? 1) / Number(data[`COUNT_OPT_${column}`]));
	const ros = isNaN(roundDecimalValueUptoTwo(Number(totalQty / 180))) ? 0 : roundDecimalValueUptoTwo(Number(totalQty / 180));
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
			<span>{data[column]}</span>

			<HtmlTooltip
				title={
					<Fragment>
						<Typography variant="body2" fontWeight={600}>
							<span style={{ color: grey[600] }}>Total Sold:</span> {data[`SOLD_QTY_${column}`]}
						</Typography>
						<Typography variant="body2" fontWeight={600}>
							<span style={{ color: grey[600] }}>Options Count:</span> {data[`COUNT_OPT_${column}`]}
						</Typography>
						<Typography variant="body2" fontWeight={600}>
							<span style={{ color: grey[600] }}>ROS: </span>
							{ros}
						</Typography>
					</Fragment>
				}>
				<Typography variant="body2" fontWeight={600} width="60%">
					{totalQty ? totalQty : 0}
				</Typography>
			</HtmlTooltip>

			<Tooltip
				title={"ROS"}
				arrow
				slotProps={{
					popper: {
						modifiers: [
							{
								name: "offset",
								options: {
									offset: [0, -14],
								},
							},
						],
					},
				}}>
				<span style={{ width: "25%", color: orange[900] }}>{ros}</span>
			</Tooltip>
		</Box>
	);
};

const HistoricalDataTable = ({ data }) => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();

	const [allChHistoricalData, setAllChHistoricalData] = useState();
	const [histDataLoad, setHistDataLoad] = useState(false);

	const mrpHistoricalTableColumns = [
		converAttrToDatagridCol({ name: "MRP", key: "mrp" }),
		...Object.keys(channelTypes).map((row) => {
			return {
				...converAttrToDatagridCol({ ...channelTypes[row], key: `${channelTypes[row]?.key}` }),
				renderCell: ({ field, row }) => {
					return <RenderQtyRosData column={field} data={row} />;
				},
			};
		}),
		{
			...converAttrToDatagridCol({ name: "TOTAL", key: `TOTAL` }),
			renderCell: ({ field, row }) => {
				return <RenderQtyRosData column={field} data={row} />;
			},
		},
	];

	const fetch = async () => {
		setHistDataLoad(true);
		try {
			await axios
				.get(
					`/api/color_buying/buying_historical_all_channel_tot_qty?brand=${data?.brand}&category=${
						data?.category
					}&sub_category=${data?.sub_category}&color=${data?.color}&season=${data?.season}&mrp=${
						data?.suggested_mrp ? data?.suggested_mrp : ""
					}`
				)
				.then((res) => {
					let data = res.data;
					setAllChHistoricalData(
						data?.result?.map((row, i) => {
							return {
								...row,
								id: new Date().valueOf() + i,
							};
						})
					);
					setHistDataLoad(false);
				});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
		}
	};
	useEffect(() => {
		fetch();
	}, [data]);

	return (
		<Box width="100%">
			{histDataLoad ? (
				<Box width="100%" height={130} display="flex" justifyContent="center" alignItems="center">
					<CircularProgress />
				</Box>
			) : (
				<Box>
					<DataGrid
						rows={allChHistoricalData ?? []}
						columns={mrpHistoricalTableColumns}
						hideFooter
						sx={{
							height: 130,
							border: `1px solid ${grey[300]}`,
							"& .MuiDataGrid-row": {
								// borderBottom: "1px solid lightgray",
								// cursor: "pointer",
								border: "none",
							},
							"& .MuiDataGrid-cell": {
								// borderBottom: "1px solid lightgray",
								// cursor: "pointer",
								borderRight: `1px solid ${grey[300]}`,
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								borderRight: `1px solid ${grey[300]}`,
							},
							"& .MuiDataGrid-columnHeaders": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
							"& .MuiDataGrid-cell": {
								padding: "2px",
								borderRight: `1px solid ${grey[200]}`,
							},
							"& .MuiDataGrid-row:hover": {
								backgroundColor: "inherit", // Or 'transparent' or whatever color you'd like
							},
						}}
						columnHeaderHeight={35}
						rowHeight={30}
						disableRowSelectionOnClick
					/>
				</Box>
			)}
		</Box>
	);
};

export default HistoricalDataTable;
